module.exports = __webpack_public_path__ + "img/ams.4650d484.jpg";